import { render, staticRenderFns } from "./DownloadCertificate.vue?vue&type=template&id=0aa7a1be&"
import script from "./DownloadCertificate.vue?vue&type=script&lang=js&"
export * from "./DownloadCertificate.vue?vue&type=script&lang=js&"
import style0 from "./DownloadCertificate.vue?vue&type=style&index=0&id=0aa7a1be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports